import React from 'react';
import './Partners.css';
import { useLanguage } from './LanguageContext';
import translations from './translations';

function Partners() {
  const { language } = useLanguage();
  const t = translations[language];
  return (
    <div className="partners-section">
      <h1 className="partners-title">{t.partnersTitle}</h1>
      <div className="partners-img-wrap">
        <img src="/p.png" alt="Our Partners" />
      </div>
    </div>
  );
}

export default Partners;